// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grafaiai: PokeData = {
  "id": 945,
  "name": "grafaiai",
  "height": 7,
  "weight": 272,
  "base_experience": 170,
  "types": [
    PokeType.POISON,
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "leer",
    "fury-swipes",
    "slash",
    "substitute",
    "flatter",
    "taunt",
    "knock-off",
    "poison-fang",
    "u-turn",
    "poison-jab",
    "switcheroo",
    "gunk-shot",
    "acid-spray",
    "doodle"
  ],
  "moves": [
    "scratch",
    "leer",
    "flatter",
    "poison-fang",
    "poison-jab",
    "mortal-gas",
    "toxic-overload",
    "poison-gas",
    "purify",
    "purification",
    "body-slam",
    "poison-powder",
    "toxic-spikes"
  ],
  "evolution_chain": {
    "id": 494,
    "item": null,
    "species": [
      {
        "name": "shroodle",
        "order": 968,
        "types": [
          PokeType.POISON,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grafaiai",
        "order": 969,
        "types": [
          PokeType.POISON,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 944,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 163,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
